export default {
  'faculty': {
    'f001': 'คณะวิทยาศาสตร์การกีฬาและสุขภาพ',
    'f002': 'คณะศิลปศาสตร์',
    'f003': 'คณะศึกษาศาสตร์'
  },
  'year': {
    '2559': {
      'f001': [
        {
          'budget': 60400,
          'period': '25-03-2559',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'แรงจูงใจในการออกกำลังกายของประชาชนในจังหวัดชุมพร',
          'owner': 'นายทิชา  สังวรกาญจน์ และนายอภิวัฒน์  จำเดิม'
        }
      ],
      'f002': [
        {
          'budget': 83028,
          'period': '02-12-2558',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'ผลการใช้สารสนเทศทางสุขภาพสำหรับผู้สูงอายุกลุ่มโรคไม่ติดต่อเรื้อรัง: กรณีศึกษาผู้ป่วยศูนย์บริการสาธารณสุขเทศบาลเมืองชุมพร จังหวัดชุมพร',
          'owner': 'ผู้ช่วยศาสตราจารย์อุไรวรรณ  วรกุลรังสรรค์'
        },
        {
          'budget': 58840,
          'period': '11-12-2558',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'พฤติกรรมของนักท่องเที่ยวที่มีต่อแหล่งท่องเที่ยวในจังหวัดชุมพร',
          'owner': 'นางสาวภควรรณ  ชวาสิทธิ์'
        },
        {
          'budget': 55000,
          'period': '22-12-2558',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้คณะศิลปศาสตร์)',
          'name': 'ความรู้และทัศนะของนักศึกษาเกี่ยวกับการจัดการทรัพยากรมนุษย์: กรณีศึกษานักศึกษาระดับปริญญาตรี คณะศิลปศาสตร์ สถาบันการพลศึกษา วิทยาเขตภาคใต้',
          'owner': 'ผู้ช่วยศาสตราจารย์นวรัตน์  เจริญสุข'
        },
        {
          'budget': 57500,
          'period': '22-01-2559',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'ผลการใช้เทคนิคการสอนแบบ PBL ในการสอนวิชาภาษาอังกฤษเพื่อการสื่อสาร',
          'owner': 'นางสาวธีรดา  ศิริภิรมย์'
        }
      ],
      'f003': [
        {
          'budget': 270000,
          'period': '23-11-2558',
          'fund_source': 'เงินอุดหนุน',
          'name': 'การพัฒนารูปแบบการเรียนรู้แบบผสมผสานโดยบูรณาการการวิจัยในการเรียนการสอนสำหรับสถาบันการพลศึกษา',
          'owner': 'ผู้ช่วยศาสตราจารย์ ดร.นฤมล  รอดเนียม'
        },
        {
          'budget': 57300,
          'period': '01-12-2558',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'ปัจจัยที่มีอิทธิพลต่อการปลูกฝังคุณธรรมและจริยธรรมของนักศึกษาสถาบันการพลศึกษา  วิทยาเขตชุมพร',
          'owner': 'รองศาสตราจารย์มลิวัลย์  ผิวคราม'
        },
        {
          'budget': 70800,
          'period': '01-12-2558',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'องค์ประกอบที่มีผลต่อพฤติกรรมการออกกำลังกายของนักศึกษาสถาบันการพลศึกษา',
          'owner': 'ผู้ช่วยศาสตราจารย์พิชัย  ผิวคราม  รองศาสตราจารย์มลิวัลย์  ผิวคราม และนายสุทิน  ตระหง่าน'
        },
        {
          'budget': 43800,
          'period': '16-12-2558',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'ความคิดเห็นของนักศึกษาที่มีต่อการจัดสภาพแวดล้อมในสถาบันการพลศึกษา  วิทยาเขตชุมพร',
          'owner': 'ผู้ช่วยศาสตราจารย์ ดร.วัชชิรา  ศักดิ์สนิท'
        }
      ]
    },
    '2560': {
      'f001': [
        {
          'budget': 64900,
          'period': '09-12-2559',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'การทดสอบความแข็งแรงของกล้ามเนื้อและปริมาณการใช้ออกซิเจนสูงสุดในนักกีฬาฟุตบอลสโมสรชุมพร',
          'owner': 'นายนพดล  มณีแดง และผศ.ลีนา  ทองมาก'
        },
        {
          'budget': 120000,
          'period': '11-11-2559',
          'fund_source': 'งบอุดหนุน',
          'name': 'ผลของการฝึกความแข็งแรงกล้ามเนื้อแกนกลางลำตัวที่มีต่อการทรงตัวและความแม่นยำในการยิงลูกเปตอง',
          'owner': 'นายอภิวัฒน์  จำเดิม และนายโรจน์รวี  ชัยรัตน์'
        }
      ],
      'f002': [
        {
          'budget': 91310,
          'period': '03-11-2559',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'ผลการเรียนรู้ด้วยบทเรียนผ่านเว็บรายวิชาสารสนเทศเพื่อการศึกษาค้นคว้า',
          'owner': 'ผู้ช่วยศาสตราจารย์อุไรวรรณ  วรกุลรังสรรค์'
        },
        {
          'budget': 72100,
          'period': '27-12-2559',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'คุณลักษณะอันพึงประสงค์ของบุคลากรสายสนับสนุนต่อการให้บริการส่วนงานที่เกี่ยวข้องกับสถาบันการพลศึกษา',
          'owner': 'ผู้ช่วยศาสตราจารย์นวรัตน์  เจริญสุข'
        },
        {
          'budget': 45000,
          'period': '20-04-2560',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศิลปศาสตร์',
          'name': 'ทัศนคติของนักศึกษาคณะศิลปศาสตร์ สถาบันการพลศึกษา   วิทยาเขตชุมพร ที่มีต่อการจัดการเรียนการสอนกลุ่มวิชาเฉพาะด้านการท่องเที่ยว',
          'owner': 'นางสาวทัศนียา  ถึงอินทร์'
        }
      ],
      'f003': [
        {
          'budget': 56000,
          'period': '05-04-2560',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศึกษาศาสตร์',
          'name': 'การพัฒนาแบบวัดคุณลักษณะการเรียนรู้ด้วยการชี้นำตนเองสำหรับนักศึกษาสถาบันการพลศึกษา วิทยาเขตชุมพร',
          'owner': 'นางสาวรังสิมาภรณ์  หนูน้อย และผู้ช่วยศาสตราจารย์นาฎยา  นิลทจันทร์'
        },
        {
          'budget': 94765,
          'period': '07-11-2559',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'การพัฒนาสื่อการเรียนการสอนผ่านเครือข่ายอินเตอร์เน็ตรายวิชาสุขภาพสิ่งแวดล้อม',
          'owner': 'ผู้ช่วยศาสตราจารย์ ดร.วัชชิรา  ศักดิ์สนิท'
        },
        {
          'budget': 95000,
          'period': '08-11-2559',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'การพัฒนาบทเรียนคอมพิวเตอร์บนเครือข่ายอินเตอร์เน็ต: การวิจัยทางการศึกษา',
          'owner': 'รองศาสตราจารย์มลิวัลย์  ผิวคราม'
        },
        {
          'budget': 69700,
          'period': '14-11-2559',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'การวิเคราะห์องค์ประกอบความมีน้ำใจนักกีฬาของนักศึกษา  สาขาพลศึกษา  สถาบันการพลศึกษา',
          'owner': 'ผู้ช่วยศาสตราจารย์พิชัย  ผิวคราม'
        },
        {
          'budget': 80000,
          'period': '18-11-2559',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'การพัฒนาบทเรียนอีเลิร์นนิ่ง  วิชานวัตกรรมและเทคโนโลยีสารสนเทศทางการศึกษาและการสื่อสารเรื่องสื่อการสอนสำหรับสถาบันการพลศึกษา',
          'owner': 'ผู้ช่วยศาสตราจารย์ ดร.จงดี  กากแก้ว'
        }
      ]
    },
    '2561': {
      'f001': [
        {
          'budget': 50000,
          'period': '21-03-2561',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'การเปรียบเทียบองค์ประกอบของร่างกายและสมรรถภาพทางกายระหว่างนักกีฬาปันจักสีลัต และนักกีฬามวยไทย ในนักกีฬาระดับมหาวิทยาลัย',
          'owner': 'นายนพดล  มณีแดง  นายทิชา  สังวรกาญจน์  ผู้ช่วยศาสตราจารย์ลีนา  ทองมาก'
        }
      ],
      'f002': [
        {
          'budget': 50000,
          'period': '26-12-2560',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'การใช้สารสนเทศเพื่องานวิจัยของบุคลากรในสังกัดสถาบันการพลศึกษา',
          'owner': 'ผู้ช่วยศาสตราจารย์อุไรวรรณ  วรกุลรังสรรค์'
        },
        {
          'budget': 50000,
          'period': '29-11-2560',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'คุณลักษณะบัณฑิตที่พึงประสงค์สำหรับสถานประกอบการ กรณีศึกษาบัณฑิตสาขานันทนาการและการท่องเที่ยว คณะศิลปศาสตร์ สถาบันการพลศึกษา วิทยาเขตชุมพร',
          'owner': 'ผู้ช่วยศาสตราจารย์นวรัตน์  เจริญสุข'
        },
        {
          'budget': 50000,
          'period': '14-11-2560',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'การมีส่วนร่วมของประชาชนในการจัดการท่องเที่ยวเชิงนิเวศ : กรณีศึกษา อ.ปะทิว  จังหวัดชุมพร',
          'owner': 'นางสาวภควรรณ  ชวาสิทธิ์'
        },
        {
          'budget': 50000,
          'period': '14-06-2561',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'การสำรวจลีลาชีวิตเกี่ยวกับการเข้าร่วมกิจกรรมนันทนาการเพื่อพัฒนาคุณภาพชีวิตของผู้สูงอายุภาคใต้ : กรณีศึกษาผู้สูงอายุกลุ่มภาคใต้ตอนบน',
          'owner': 'ผู้ช่วยศาสตราจารย์ ดร.ศักดิ์  อินพิรุด'
        },
        {
          'budget': 50000,
          'period': '11-06-2561',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'การพัฒนารูปแบบการท่องเที่ยวโฮมสเตย์ จังหวัดชุมพร',
          'owner': 'นางสาวทัศนียา  ถึงอินทร์'
        }
      ],
      'f003': [
        {
          'budget': 50000,
          'period': '22-12-2560',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'ปัจจัยที่มีผลต่อพฤติกรรมสุขภาพ 3อ 2ส ของผู้สูงอายุ : กรณีศึกษาผู้สูงอายุ ตำบลนาชะอัง อำเภอเมือง จังหวัดชุมพร',
          'owner': 'ผู้ช่วยศาสตราจารย์ ดร.วัชชิรา  ศักดิ์สนิท'
        },
        {
          'budget': 50000,
          'period': '17-11-2560',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'การพัฒนาความสามารถทั่วไปด้านการคิดคำนวณเพื่อเตรียมความพร้อมในการสอบคัดเลือกเข้ารับราชการ : กรณีศึกษานักศึกษาคณะศึกษาศาสตร์  ชั้นปีที่ ๓ สถาบันการพลศึกษา วิทยาเขตชุมพร',
          'owner': 'รองศาสตราจารย์มลิวัลย์  ผิวคราม  ผู้ช่วยศาสตราจารย์พิชัย  ผิวคราม และนายดามพ์  สุขสุวานนท์'
        },
        {
          'budget': 50000,
          'period': '21-11-2560',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'การประเมินการรู้ดิจิทัลของนักศึกษาระดับปริญญาตรีสาขาพลศึกษา สถาบันการพลศึกษา',
          'owner': 'ผู้ช่วยศาสตราจารย์ ดร.นฤมล  รอดเนียม'
        },
        {
          'budget': 50000,
          'period': '21-01-2561',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'ผลการใช้โปรแกรมการจัดกิจกรรมทางกายด้านกีฬาและนันทนาการตามนโยบายลดเวลาเรียนเพิ่มเวลารู้ที่มีผลต่อการพัฒนาความฉลาดทางอารมณ์ของนักเรียนชั้นประถมศึกษาชั้นปีที่ 4 -6',
          'owner': 'ผู้ช่วยศาสตราจารย์นงลักษณ์  สันติวณิชย์ และผู้ช่วยศาสตราจารย์ ดร.นฤมล  รอดเนียม'
        }
      ]
    },
    '2562': {
      'f001': [
        {
          'budget': 240500,
          'period': '01-10-2561',
          'fund_source': 'งบอื่นๆ ',
          'name': 'ผลการฝึกพลัยโอเมตริกและการฝึกบาร์เบลสควอชที่มีต่อประสิทธิภาพการกระโดดในแนวดิ่งของนักกีฬาระดับมหาวิทยาลัย',
          'owner': 'นายนพดล  มณีแดง  นายทิชา  สังวรกาญจน์ ผู้ช่วยศาสตราจารย์ ดร.นิกร สีแล และผู้ช่วยศาสตราจารย์ลีนา  ทองมาก'
        },
        {
          'budget': 50000,
          'period': '10-01-2562',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'การพัฒนาแบบสอบถามสภาวะโช้คภายใต้ความกดดันในการแข่งขันกีฬา',
          'owner': 'ดร.เกรียงไกร นาคเทวัญ  ดร.นิกร  สีแล และนายอภิวัฒน์  จำเดิม'
        }
      ],
      'f002': [
        {
          'budget': 50000,
          'period': '23-11-2561',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'การประเมินศักยภาพและความคาดหวังในการจัดตั้งคลังปัญญาของสถาบันการพลศึกษา',
          'owner': 'ผู้ช่วยศาสตราจารย์อุไรวรรณ  วรกุลรังสรรค์'
        },
        {
          'budget': 50000,
          'period': '17-12-2561',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'ความต้องการของสถานประกอบการในการพัฒนาทรัพยากรมนุษย์ด้านการท่องเที่ยว กรณีศึกษา สถานประกอบการในจังหวัดชุมพร จังหวัดระนอง และจังหวัดสุราษฎร์ธานี',
          'owner': 'ผู้ช่วยศาสตราจารย์นวรัตน์  เจริญสุข'
        },
        {
          'budget': 50000,
          'period': '18-12-2561',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'การนำแนวคิดปรัชญาเศรษฐกิจพอเพียงมาใช้ในการดำเนินชีวิตของบุคลากร สถาบันการพลศึกษา วิทยาเขตภาคใต้',
          'owner': 'นางสาววนิดา  พูลนวล'
        },
        {
          'budget': 50000,
          'period': '18-12-2561',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'แนวทางการส่งเสริมการท่องเที่ยวผ่านอาหารพื้นเมือง จังหวัดชุมพร',
          'owner': 'นางสาวจิราภรณ์  ขาวศรี'
        },
        {
          'budget': 50000,
          'period': '12-01-2562',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศิลปศาสตร์',
          'name': 'ทัศนะคติที่มีต่อการจัดการเรียนการสอนกลุ่มวิชาเฉพาะด้านนันทนาการของนักศึกษาคณะศิลปศาสตร์ สถาบันการพลศึกษา วิทยาเขตชุมพร',
          'owner': 'นายอัมรินทร์  หัตถกิจ  และนางสาวทัศนียา  ถึงอินทร์'
        }
      ],
      'f003': [
        {
          'budget': 50000,
          'period': '21-11-2561',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'การพัฒนาบทเรียนอีเลิร์นนิงวิชาการพัฒนาหลักสูตร',
          'owner': 'ผู้ช่วยศาสตราจารย์สำเริง  วงศ์พลาย'
        },
        {
          'budget': 50000,
          'period': '15-11-2561',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'ประสิทธิผลของวิชาทักษะและการสอนกีฬา 4 ชนิดในสาขาพลศึกษาที่มีผลต่อสมรรถภาพทางกายในนักศึกษาชั้นปีที่ 1 ภาคการศึกษาที่ 1 คณะศึกษาศาสตร์ สถาบันการพลศึกษา วิทยาเขตชุมพร',
          'owner': 'ผู้ช่วยศาสตราจารย์พิชัย  ผิวคราม   รองศาสตราจารย์มลิวัลย์  ผิวคราม นายลเฉลิมพล  ก่อกิจเถกิงกูล   นายณรงค์  ชลสินธุ์  และนายจรงค์  ชายเกตุ'
        },
        {
          'budget': 50000,
          'period': '07-12-2561',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'การพัฒนาระบบสารสนเทศเพื่อการบริหารงานวิจัย สถาบันการพลศึกษา วิทยาเขตชุมพร    ',
          'owner': 'นางสาวรังสิมาภรณ์  หนูน้อย และรองศาสตราจารย์มลิวัลย์  ผิวคราม'
        },
        {
          'budget': 133815,
          'period': '12-12-2561',
          'fund_source': 'งบประมาณแผนบูรณาการการวิจัยและนวัตกรรม การส่งเสริมสุขภาพและพัฒนาคุณภาพชีวิต ประจำปีงบประมาณ พ.ศ.2562 งบประมาณ 892,100 บาท (สัดส่วนการมีส่วนร่วมของผู้ช่วยศาสตราจารย์ ดร.นฤมล  รอดเนียม 15% งบประมาณ 133,815 บาท)',
          'name': 'การพัฒนารูปแบบนวัตกรรมการส่งเสริมสุขภาวะในการทำงานของผู้หญิงวัยทำงานจังหวัดชายแดนใต้',
          'owner': 'ผู้ช่วยศาสตราจารย์วงศ์พัทธ์  ชูดำ ผู้ช่วยศาสตราจารย์ สิบเอกสุทัศน์  สีแก้วเขียว  ผู้ช่วยศาสตราจารย์ ดร.นฤมล  รอดเนียม และผู้ช่วยศาสตราจารย์สุปรียา  สิทธิกุล'
        },
        {
          'budget': 50000,
          'period': '19-12-2561',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศึกษาศาสตร์',
          'name': 'ความฉลาดทางสุขภาพและพฤติกรรมสร้างเสริมสุขภาพนักศึกษา สถาบันการพลศึกษา  วิทยาเขตชุมพร',
          'owner': 'นายศิวะ  พลนิล และผู้ช่วยศาสตราจารย์ ดร.นฤมล  รอดเนียม'
        },
        {
          'budget': 50000,
          'period': '12-01-2562',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'ผลสัมฤทธิ์ทักษะการว่ายน้ำด้วยวิธีการจัดกิจกรรมฝึกทักษะแบบแยกกลุ่มแก้ไขบกพร่อง',
          'owner': 'นายดามพ์  สุขสุวานนท์ และรองศาสตราจารย์ ดร.ชาญชัย  ศิริพันธุ์'
        }
      ]
    },
    '2563': {
      'f001': [
        {
          'budget': 50000,
          'period': '27-12-2562',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะวิทยาศาสตร์การกีฬาและสุขภาพ',
          'name': 'ความพึงพอใจของนักศึกษาต่อการจัดการเรียนการสอนหลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาวิทยาศาสตร์การออกกำลังกายและกีฬา คณะวิทยาศาสตร์การกีฬาและสุขภาพ มหาวิทยาลัยการกีฬาแห่งชาติ  วิทยาเขตชุมพร',
          'owner': 'นายวุฒิชัย  อ่อนสุด'
        }
      ],
      'f002': [
        {
          'budget': 50000,
          'period': '27-11-2562',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'ปัจจัยที่มีผลต่อการมีส่วนร่วมทางการเมืองของนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตภาคใต้',
          'owner': 'จิรยุทธ  คงพยัคฆ์'
        },
        {
          'budget': 50000,
          'period': '04-12-2562',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'การวิเคราะห์เนื้อหาวิทยานิพนธ์ มหาวิทยาลัยการกีฬาแห่งชาติ',
          'owner': 'ผู้ช่วยศาสตราจารย์อุไรวรรณ  วรกุลรังสรรค์'
        },
        {
          'budget': 50000,
          'period': '27-12-2562',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศิลปศาสตร์',
          'name': 'ปัจจัยที่ส่งผลต่อการเลือกที่พักในการท่องเที่ยวของผู้สูงอายุในจังหวัดชุมพร',
          'owner': 'นางสาวเป็นหนึ่ง  เกิดดำ'
        },
        {
          'budget': 50000,
          'period': '27-12-2562',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศิลปศาสตร์',
          'name': 'การประเมินความพึงพอใจของประชาชนในเขตเทศบาลเมืองชุมพร ที่มีต่อการจัดกิจกรรมโปรแกรมลีลาศ',
          'owner': 'ผู้ช่วยศาสตราจารย์ศักดิ์  อินพิรุด'
        },
        {
          'budget': 50000,
          'period': '27-12-2562',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศิลปศาสตร์',
          'name': 'การศึกษาคุณธรรมจริยธรรมตามหลักปรัชญาเศรษฐกิจพอเพียงของนักศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร',
          'owner': 'นางสาววนิดา  พูลนวล'
        }
      ],
      'f003': [
        {
          'budget': 50000,
          'period': '13-12-2562',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'ปัจจัยที่มีผลต่อการเป็นนักกีฬาอีสปอร์ต มหาวิทยาลัยการกีฬาแห่งชาติ',
          'owner': 'นางสาวรังสิมาภรณ์  หนูน้อย'
        },
        {
          'budget': 50000,
          'period': '09-12-2562',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศึกษาศาสตร์',
          'name': 'ปัจจัยที่ส่งผลต่อการตัดสินใจเลือกเข้าศึกษาต่อหลักสูตรพลศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร',
          'owner': 'ผู้ช่วยศาสตราจารย์พิชัย  ผิวคราม'
        }
      ]
    },
    '2564': {
      'f001': [],
      'f002': [
        {
          'budget': 50000,
          'period': '16-11-2563',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'แนวทางการดำเนินงานเพื่อเชื่อมโยงสู่ฐานข้อมูลTDC ของมหาวิทยาลัยการกีฬาแห่งชาติ',
          'owner': 'ผู้ช่วยศาสตราจารย์อุไรวรรณ  วรกุลรังสรรค์'
        },
        {
          'budget': 50000,
          'period': '21-04-2564',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'การพัฒนาศักยภาพทรัพยากรมนุษย์ของธุรกิจท่องเที่ยวในภาคใต้ 5 จังหวัด ที่ได้รับผลกระทบจากการแพร่ระบาดของ COVID 19',
          'owner': 'ผู้ช่วยศาสตราจารย์นวรัตน์  เจริญสุข'
        },
        {
          'budget': 50000,
          'period': '04-08-2564',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศิลปศาสตร์',
          'name': 'แนวทางการการมีส่วนร่วมในกิจกรรมนันทนาการของผู้สูงอายุในสี่จังหวัดภาคใต้ดำเนินงานเพื่อเชื่อมโยงสู่ฐานข้อมูลTDC ของมหาวิทยาลัยการกีฬาแห่งชาติ',
          'owner': 'นายอมรินทร์  หัตถกิจ'
        }
      ],
      'f003': [
        {
          'budget': 50000,
          'period': '16-11-2563',
          'fund_source': 'งบประมาณรายจ่าย',
          'name': 'ปัจจัยที่มีผลต่อการเผลกระทบของสถานการณ์การแพร่ระบาดของโรคติดต่อเชื้อไวรัสโคโรนา 2019 ที่มีต่อนักกีฬากาบัดดี้',
          'owner': 'นายเจนวิทย์  ดิษขนาน และนางสาวรังสิมาภรณ์  หนูน้อย'
        },
        {
          'budget': 50000,
          'period': '25-06-2564',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้)',
          'name': 'การพัฒนาโปรแกรมการให้คำปรึกษาแบบกลุ่มที่มีผลต่อความเจริญงอกงามของนักศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร',
          'owner': 'นายกฤษณะ  เริงสูงเนิน'
        },
        {
          'budget': 50000,
          'period': '25-06-2564',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศึกษาศาสตร์',
          'name': 'การพัฒนารูปแบบการเรียนรู้ออนไลน์ด้วยวิธีการผสมผสานที่ใช้การเรียนรู้โดยใช้ปัญหาเป็นฐานและกลวิธีการกำกับตนเองสำหรับนักศึกษาปริญญาตรี',
          'owner': 'นายดามพ์  สุขสุวานนท์ และผู้ช่วยศาสตราจารย์ ดร.นฤมล  รอดเนียม'
        }
      ]
    },
    '2565': {
      'f001': [],
      'f002': [],
      'f003': []
    },
    '2566': {
      'f001': [],
      'f002': [
        {
          'budget': 29140,
          'period': '11-11-2565',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศิลปศาสตร์',
          'name': 'ปัจจัยที่มีอิทธิพลต่อพฤติกรรมการท่องเที่ยวเชิงสุขภาพของผู้สูงอายุจังหวัดชุมพร',
          'owner': 'นางสาวทัศนียา ถึงอินทร์'
        }
      ],
      'f003': [
        {
          'budget': 28100,
          'period': '01-12-2565',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศึกษาศาสตร์',
          'name': 'การพัฒนาแบบวัดทักษะกีฬากาบัดดี้ สำหรับนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ',
          'owner': 'นางสาวรังสิมาภรณ์ หนูน้อย และนายเจนวิทย์ ดิษขนาน'
        },
        {
          'budget': 31900,
          'period': '13-12-2565',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศึกษาศาสตร์',
          'name': 'การพัฒนารูปแบบการให้คำปรึกษากลุ่มแบบ บูรณาการที่มีผลต่อความเหนื่อยหน่ายในการเรียนของนักศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร',
          'owner': 'นายกฤษณะ เริงสูงเนิน'
        },
        {
          'budget': 39220,
          'period': '06-12-2565',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) ฝ่ายวิจัยและประกันคุณภาพการศึกษา',
          'name': 'โปรแกรมสุขศึกษาเพื่อปรับเปลี่ยนพฤติกรรมการอ่านฉลากโภชนาการแบบจีดีเอ (Guideline Daily Amounts : GDA) โดยประยุกต์ทฤษฎีการรับรู้ความสามารถตนเองร่วมกับแรงสนับสนุนทางสังคมในนักศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร',
          'owner': 'นางสาวเบญจมาศ พูลสวัสดิ์'
        }
      ]
    },
    '2567': {
      'f001': [],
      'f002': [
        {
          'budget': 31120,
          'period': '30-10-2566',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศิลปศาสตร์',
          'name': 'แนวทางการพัฒนาสินค้าที่ระลึกเพื่อการท่องเที่ยวที่สะท้อนอัตลักษณ์ท้องถิ่น จังหวัดชุมพร',
          'owner': 'นางสาวจิราภรณ์  ขาวศรี'
        },
        {
          'budget': 58800,
          'period': '07-11-2566',
          'fund_source': 'งบประมาณรายจ่าย (เงินงบประมาณแผ่นดิน)งบประมาณ 196,000 บาท (สัดส่วนการมีส่วนร่วมของนางสาวจิราภรณ์  ขาวศรี 30% งบประมาณ 58,800 บาท)',
          'name': 'การพัฒนาแบบวัดทักษะการคิดเชิงบริหารสำหรับนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ',
          'owner': 'นางสาวจิราภรณ์  ขาวศรี'
        }
      ],
      'f003': [
        {
          'budget': 137200,
          'period': '01-11-2566',
          'fund_source': 'งบประมาณรายจ่าย (เงินงบประมาณแผ่นดิน)งบประมาณ 196,000 บาท (สัดส่วนการมีส่วนร่วมของนางสาวรังสิมาภรณ์  หนูน้อย 50% และนายเจนวิทย์ ดิษขนาน 20% งบประมาณ 137,200 บาท)',
          'name': 'การพัฒนาแบบวัดทักษะการคิดเชิงบริหารสำหรับนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ',
          'owner': 'นางสาวรังสิมาภรณ์ หนูน้อย และนายเจนวิทย์ ดิษขนาน'
        }
      ]
    },
    '2568': {
      'f001': [],
      'f002': [
        {
          'budget': 29575,
          'period': '30-10-2567',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศิลปศาสตร์',
          'name': 'ปัจจัยส่วนประสมทางการตลาดที่มีผลต่อการตัดสินใจท่องเที่ยวเชิงกีฬาทางทะเลจังหวัดชุมพร',
          'owner': 'นางสาวทัศนียา ถึงอินทร์'
        },
        {
          'budget': 38515,
          'period': '30-10-2567',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) ฝ่ายวิจัยและประกันคุณภาพการศึกษา',
          'name': 'การพัฒนานวัตกรรมบอร์ดกู้ภัยทางน้ำ (ระยะ1)',
          'owner': 'นายอัศวิน มณีอินทร์'
        },
        {
          'budget': 16860,
          'period': '16-10-2567',
          'fund_source': 'งบประมาณรายจ่าย (เงินงบประมาณแผ่นดิน)งบประมาณ 168,600 บาท (สัดส่วนการมีส่วนร่วมของนางสาวจิราภรณ์  ขาวศรี 10% งบประมาณ 16,860 บาท)',
          'name': 'การพัฒนาระบบคลังข้อสอบการวิจัยและนวัตกรรมเพื่อการเรียนรู้มหาวิทยาลัยการกีฬาแห่งชาติ',
          'owner': 'นางสาวจิราภรณ์  ขาวศรี'
        }
      ],
      'f003': [
        {
          'budget': 25000,
          'period': '30-10-2567',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศึกษาศาสตร์',
          'name': 'การศึกษาความต้องการบริหารขั้นพื้นฐานและความพึงพอใจของนักศึกษาคณะศึกษาศาสตร์ มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร',
          'owner': 'นางสาวเบญจมาศ พูลสวัสดิ์ และนายวศิน โต๊ะแสง'
        },
        {
          'budget': 26696,
          'period': '30-10-2567',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) ฝ่ายวิจัยและประกันคุณภาพการศึกษา',
          'name': 'การพัฒนาโปรแกรมการปรึกษากลุ่มแบบบูรณาการเพื่อเสริมสร้างการกำกับอารมณ์ของนักศึกษาระดับปริญญาตรีกลุ่มเสี่ยงต่อภาวะซึมเศร้า',
          'owner': 'นายกฤษณะ เริงสูงเนิน'
        },
        {
          'budget': 50580,
          'period': '16-10-2567',
          'fund_source': 'งบประมาณรายจ่าย (เงินงบประมาณแผ่นดิน)งบประมาณ 168,600 บาท (สัดส่วนการมีส่วนร่วมของนางสาวรังสิมาภรณ์  หนูน้อย 25% และนายเจนวิทย์ ดิษขนาน 5% งบประมาณ 50,580 บาท)',
          'name': 'การพัฒนาระบบคลังข้อสอบการวิจัยและนวัตกรรมเพื่อการเรียนรู้มหาวิทยาลัยการกีฬาแห่งชาติ',
          'owner': 'นางสาวรังสิมาภรณ์ หนูน้อย และนายเจนวิทย์ ดิษขนาน'
        }
      ]
    },
    '2569': {
      'f001': [
        {
          'budget': 22120,
          'period': '13-11-2568',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะวิทยาศาสตร์การกีฬาและสุขภาพ',
          'name': 'ทฤษฎีบทจุดตรึงสำหรับการวางนัยทั่วไปของการส่งหดตัว L ในปริภูมิเมตริกบางส่วน',
          'owner': 'นายวุฒิชัย อ่อนสด'
        }
      ],
      'f002': [
        {
          'budget': 26800,
          'period': '15-01-2569',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศิลปศาสตร์',
          'name': 'ปัจจัยที่ส่งผลต่อความตั้งใจใช้เทคโนโลยี AI ของนักท่องเที่ยว',
          'owner': 'นางสาวทัศนียา ถึงอินทร์'
        }
      ],
      'f003': [
        {
          'budget': 27640,
          'period': '30-10-2568',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) ฝ่ายวิจัยและประกันคุณภาพการศึกษา',
          'name': 'การพัฒนาแบบทดสอบผลลัพธ์การเรียนรู้ทักษะกีฬาเทเบิลเทนนิลสำหรับนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ',
          'owner': 'ผู้ช่วยศาสตราจารย์ ดร.รังสิมาภรณ์ หนูน้อย และนายเจนวิทย์ ดิษขนาน'
        },
        {
          'budget': 20000,
          'period': '14-11-2568',
          'fund_source': 'งบประมาณรายจ่าย (เงินรายได้) คณะศึกษาศาสตร์',
          'name': 'ผลของโปรแกรมฝึกสติที่เน้นการรับรู้ปัจจุบันขณะร่วมกับกลยุทธ์การกำกับตนเองที่มีต่อทักษะการบริหารจัดการเวลาของนักศึกษาวิชาชีพครูชั้นปีที่ 1 มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร',
          'owner': 'ผู้ช่วยศาสตราจารย์ ดร.นฤมล รอดเนียม และว่าที่ร้อยตรีอนุรักษ์ ปักการะนัง'
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/data/research.js